export default __webpack_public_path__ + "static/149-min-min-154cb0219b28063f22410c6d0ddb8fb3.jpg";